const jquery = require("jquery");

window.jQuery = jquery;
window.$ = jquery;
